import { createFileRoute } from '@tanstack/react-router';
import { MasterGeralScreen } from '@/mobile/master/screens/MasterGeralScreen';

export const Route = createFileRoute('/m/master/')({
  component: MasterGeralScreen,
});
